import "../components/error/style.scss"

import { Link } from "gatsby"
import * as React from "react"

import Head from "../components/head"
import Layout from "../components/layout"

const linksContainerStyles = {
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  justifyContent: "center",
  marginTop: "20px"
}

const linkStyles = {
  padding: "12px 24px",
  backgroundColor: "#007bff",
  color: "white",
  textDecoration: "none",
  borderRadius: "4px",
  fontSize: "16px",
  fontWeight: "500",
  transition: "background-color 0.3s"
}

// markup
const NotFoundPage = () => (
  <div className="error-page">
    <Head
      title="404: Page Not Found - TFSports"
      description="The page you are looking for could not be found. Browse our events or return to the homepage."
      keywords="404, page not found, TFSports"
    />
    <Layout>
      <main>
        <h1>404 - Page Not Found 🚧</h1>
        <p>
          We're sorry, but the page you are looking for doesn't exist or has been moved.
          <br />
          Don't worry, you can find what you're looking for from the links below.
        </p>
        <div style={linksContainerStyles}>
          <Link to="/" style={linkStyles}>
            Go to Homepage
          </Link>
          <Link to="/events" style={linkStyles}>
            Browse Events
          </Link>
        </div>
      </main>
    </Layout>
  </div>
)

export default NotFoundPage
